module.exports = __webpack_public_path__ + "media/assets/images/blog/kanban_cartoon-small-d79717603392a71f911dbf7077b0ce56.jpg";